<app-floating-visor style="position: absolute; user-select: none; z-index: 120; height: 0px;" [width]="previewSizeW"
  [height]="previewSize" [left]="previewLeft" [top]="60" [showWindowingTool]="showWindowingTool"
  (addLastStep)="addLastStep()" (closeVisor)="showMenu()">
</app-floating-visor>

<div class="w-100 h-100 d-flex justify-content-center align-items-center"
  style="position:absolute;top:0;left:0; z-index: 999; background-color: rgba(139, 139, 139, 0.486);"
  *ngIf='showSpinner'>
  <div class="spinner-border text-light" role="status">
  </div>
  <span class="ms-3">Loading...</span>
</div>

<app-side-options-desktop *ngIf="!isPageSmall" [caducityTime]="caducityTime!" [token]="token"
  (onClickRenew)="refreshCaducity()" (onClickShare)="openShareModal()" (initDesktopTour)="startDesktopTour()"
  (stepBackToVisor)="this.viewers.first.openVisor()"></app-side-options-desktop>

<!-- <app-side-options-mobile *ngIf="isPageSmall" [caducityTime]="caducityTime"></app-side-options-mobile> -->

<div
  style="position: absolute; left: 30px;width: 500px; top:150px;font-size: 36px; display: flex;justify-content: center;"
  *ngIf="pageNumber==0 && !isPageSmall" [innerHTML]="bookName">
</div>

<!-- Botón de descargar informe en la versión móvil -->

<!-- HEADER PARA EL LANDSCAPE -->
<div *ngIf="isPageSmall">
  <!--<app-header *ngIf="!visorOpen" [token]="token" (initHorizontalTour)="startHorizontalMobileTour()"
    (sendMail)="sendMail($event)"></app-header>-->
  <app-horizontal-header 
    [activeTab]="'book'"
    [isVertical]="false"
    (menuClick)="toggleMenu()"
    (onClickViewer)="openAdvancedVisor()">
  </app-horizontal-header>

  <app-side-menu
    [visibleButtons]="['download','share','info','report','viewer','book']"
    [opened]="menuOpened"
    [actualBookStudies]="bookStudies"
    (close)="closeMenu()"
    (onClickShare)="openShareModal()"
    (onClickInfo)="openInfoModal()"
    (onClickViewer)="openAdvancedVisor()"
    (onClickChangeTab)="openReportModal($event)">
  </app-side-menu>
    
</div>

<!-- ACABA EL HEADER PARA EL LANDSCAPE -->

<div id="reportContainer" class="report-container" (mouseup)="resetDeltas()"
  *ngIf="reportService.actualReport!=undefined"
  style="max-height: calc(100% - 53px); max-width: 33%; width: auto; position: absolute; top: 53px;border-radius: 8px;"
  [@showReport]="calculateShowReportAnimation()"
  [ngStyle]="{width:reportService.actualReport.type=='pdf' || reportService.activatedAI ? '33%' : 'auto', overflow: reportService.actualReport.type=='html' ? 'hidden' : (reportService.activatedAI) ? 'visible' : 'auto', boxShadow: reportService.actualReport.type=='html' ? '2px 2px 16px #73a5f060' : 'none'}">

  <div *ngIf="!this.tourService.guideTour.isActive() && !reportService.activatedAI">
    <button type="button" class="round-button more-zoom" *ngIf=" !isPageSmall" (click)='increaseZoom()'>
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.3779 8.34092H9.85016V3.81321C9.85016 3.61308 9.77066 3.42113 9.62914 3.27962C9.48762 3.1381 9.29568 3.05859 9.09554 3.05859C8.8954 3.05859 8.70346 3.1381 8.56195 3.27962C8.42043 3.42113 8.34092 3.61308 8.34092 3.81321V8.34092H3.81321C3.61308 8.34092 3.42113 8.42043 3.27962 8.56195C3.1381 8.70346 3.05859 8.8954 3.05859 9.09554C3.05859 9.29568 3.1381 9.48762 3.27962 9.62914C3.42113 9.77066 3.61308 9.85016 3.81321 9.85016H8.34092V14.3779C8.34092 14.578 8.42043 14.7699 8.56195 14.9115C8.70346 15.053 8.8954 15.1325 9.09554 15.1325C9.29568 15.1325 9.48762 15.053 9.62914 14.9115C9.77066 14.7699 9.85016 14.578 9.85016 14.3779V9.85016H14.3779C14.578 9.85016 14.7699 9.77066 14.9115 9.62914C15.053 9.48762 15.1325 9.29568 15.1325 9.09554C15.1325 8.8954 15.053 8.70346 14.9115 8.56195C14.7699 8.42043 14.578 8.34092 14.3779 8.34092Z"
          fill="#E2E7F4" />
      </svg>
    </button>
    <button type="button" class="round-button less-zoom" *ngIf=" !isPageSmall" (click)='decreaseZoom()'>
      <svg width="19" height="19" viewBox="0 0 19 19" fill="white" xmlns="http://www.w3.org/2000/svg">
        <line x1="4" y1="9.5" x2="15" y2="9.5" stroke="white" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
    <!--<button type="button" class="round-button print" *ngIf=" !isPageSmall"
      (click)='studiesService.downloadReport(bookService.currentBook!.studyUIDs)' title="Descargar informe">
      <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 0V7.5H2.5L10 15L17.5 7.5H12.5V0H7.5ZM0 17.5V20H20V17.5H0Z" fill="white" />
      </svg>
    </button>-->
  </div>

  <!--<div class="print-text d-flex justify-content-center"><small>{{'MENU.DOWNLOAD' | translate}}<br>{{'REPORT' |
      translate}}</small></div>-->

  <!-- Informes PNG -->
  <div
    *ngIf="reportService.actualReport!=undefined && reportService.actualReport.type=='png' && !reportService.activatedAI"
    style="background-color: white;padding: 5px;border-right: 1px solid black;width: 100%;height: 100%;">
    <div id="externalReportDiv" class="reportDiv" style="height: 100%; overflow: auto; background-color: white;">
      <div style="display: inline-block; position: relative; background-color: white;" class='book-image-container'
        [style.height.%]="flipbookHeight" [style.width.%]="flipbookHeight">
        <img draggable="false" [src]="reportService.actualReport.data">
      </div>
    </div>
  </div>

  <!-- Informes PDF -->
  <div class="p-relative h-100 w-100"
    *ngIf="reportService.actualReport!=undefined && reportService.actualReport.type=='pdf' && !reportService.activatedAI">
    <pdf-viewer #pdfViewerMain [src]="reportService.actualReport.data" [render-text]="true" [original-size]="false"
      [zoom]="pdfZoom" [render-text-mode]="2" (after-load-complete)="onPdfLoaded(pdfViewerMain)"
      style="width: 100%; height: 100%">
    </pdf-viewer>
  </div>


  <!-- Informes html -->
  <div class="w-100 h-100 p-4" style="background-color: white; color: black !important; overflow: auto;"
    *ngIf="reportService.actualReport!=undefined && reportService.actualReport.type=='html' && !reportService.activatedAI"
    [style.fontSize]="reportFontSize + 'px'" [innerHTML]="reportService.actualReport.data">
  </div>

  <!-- Informes IA -->
  <div class="w-100 h-100 p-4 ai-report" *ngIf="reportService.actualReport!=undefined && reportService.activatedAI"
    [style.fontSize]="reportFontSize + 'px'">
    <app-ai-report></app-ai-report>
  </div>

  <button type="button" *ngIf="reportService.hasPrev() && !isPageSmall" class="btn change-page"
    style="left: calc(50% - 50px); bottom: 3%; background-color: #101D30;" (click)='reportService.prevReport()'>
    &lt;
  </button>
  <span *ngIf="reportService.reports.length > 1 && !isPageSmall && !reportService.activatedAI" class="report-index"
    style="bottom: 3%; color: black !important;">
    {{reportService.reportIndex + 1}} / {{reportService.reports.length}}
  </span>
  <button type="button" *ngIf="reportService.hasNext() && !isPageSmall" class="btn change-page"
    style="left: calc(50% + 50px); bottom: 3%; background-color: #101D30;" (click)='reportService.nextReport()'>
    &gt;
  </button>

  <div class="clickable" style="position: absolute; top: 10px; right: 10px; display: flex; align-items: center;"
    *ngIf="!reportService.activatedAI && reportService.aiData!=null" (click)="reportService.activatedAI = true">
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28 0C26.632 4.944 24.87 6.633 20 8C24.87 9.367 26.632 11.056 28 16C29.368 11.056 31.13 9.367 36 8C31.13 6.633 29.368 4.944 28 0ZM14 8C11.605 16.651 8.524 19.608 0 22C8.524 24.392 11.605 27.349 14 36C16.395 27.349 19.476 24.392 28 22C19.476 19.608 16.395 16.651 14 8Z"
        fill="#F1C250" />
    </svg>
    <span style="color: #F1C250; font-size: 34px; margin-left: 5px;">IA</span>
  </div>
  <!-- <span class="clickable underline" style="position: absolute; bottom: 10px; left: 20%; color: #004cff;" *ngIf="!reportService.activatedAI && reportService.aiData!=null"
  (click)="reportService.activatedAI = true">Potenciar con Inteligencia Artificial</span> -->
</div>

<div id="flipbookContainer" class="container-fluid h-100 w-100" (mouseup)="resetDeltas()">
  <!-- Header -->
  <div class="row g-0 p-2" style="height: 53px;" *ngIf="!globalVariables.isPageSmall">
    <div class="col d-flex justify-content-between">
      <img src="assets/img/Logo Vertical.svg" class="clickable" height="40px"
        (click)="(company==Company.DEBRAIN) ? window.location.href='http://www.debrain-he.com/products?product=DIGITALBOOK' : window.location.href='http://www.m3meuropa.com/products?product=DIGITALBOOK'">
      <span style="font-size: 20px;color:#f2c63d">{{"HEADER.TITLE" | translate}}</span>


      <!--  ESTO ES PARA EL PORTAL PACIENTE DEMO -->

      <div class="d-flex justify-content-end align-items-center">
        <span class="me-2" style="cursor: pointer; z-index: 1;" *ngIf="environment.demo">
          <svg (click)="expandedIndex=true" *ngIf="!expandedIndex" xmlns="http://www.w3.org/2000/svg" height="22px"
            viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
          </svg>
          <svg (click)="expandedIndex=false" *ngIf="expandedIndex" xmlns="http://www.w3.org/2000/svg" height="22px"
            viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
          </svg>
        </span>
        <span class='prp-icons icon-m3m-logo clickable' *ngIf="company==Company.M3M"
          style="font-size: 18px; color:turquoise !important;" height="18"
          (click)="window.location.href='http://www.m3meuropa.com'"></span>
        <span class='ps-icons icon-debrain clickable' *ngIf="company==Company.DEBRAIN"
          style="font-size: 14px; color:turquoise !important;" height="12"
          (click)="window.location.href='http://www.debrain-he.com'"></span>
      </div>

      <!--<span class='prp-icons icon-m3m-logo clickable' *ngIf="company==Company.M3M"
        style="font-size: 18px; color:turquoise !important;" height="18"
        (click)="window.location.href='http://www.m3meuropa.com'"></span>-->


    </div>
  </div>

  <!-- Book -->
  <div id="bookRow" class="row g-0"
    [ngStyle]="{maxHeight:(globalVariables.isPageSmall) ? 'calc(100%)' : 'calc(100% - 53px)'}"
    *ngIf="bookService.currentBook!=null">
    <div class="col-12 h-100" id="wrapper" [ngClass]='{wrapper:flipbookLoaded}'
      [ngStyle]="{visibility: flipbookLoaded ? 'visible' : 'hidden'}">

      <div class="new-card tip" *ngIf="!isPageSmall" style="transition: 1s;"
        [ngStyle]="{opacity: (isShowingCover) ? '1' : '0'}">
        <span class="text-golden">
          {{'TIPS.TIP_1' | translate}}
        </span>
      </div>


      <div id="flipbook" [@centerBook]="calculateCenterBookAnimation()">
        <div class="page report-container" *ngFor='let page of bookService.currentBook.pages'
          [ngClass]="{transparent: isReportTransparent(page)}">
          <div style="background-color: white;padding: 5px;border-right: 1px solid black;width: 100%;height: 100%;">
            <div id="internalReportDiv" style="height: 100%;" [ngClass]="{reportDiv:page.type == BookPageType.REPORT}"
              [ngStyle]="{overflow: (flipbookHeight>100 && page.type == BookPageType.REPORT) ? 'auto' : 'hidden', backgroundColor: (page.type == BookPageType.IMAGES) ? 'black' : 'white'}">
              <div *ngFor='let img of page.bookImages' style="display: inline-block; position: relative;"
                (click)="(page.type == BookPageType.IMAGES && img.dicomFile) ? openPreview(img, $event) : null"
                [ngClass]="{clickable:img.dicomFile!=null && img.dicomFile!=''}"
                class='book-image-container'
                [style.height.%]="(page.type == BookPageType.REPORT) ? flipbookHeight : img.height"
                [style.width.%]="(page.type == BookPageType.REPORT) ? flipbookHeight : img.width"
                [style.borderColor]="(page.type == BookPageType.IMAGES && img.isKo) ? '#f2c63d08' : ''">
                <div class="w-100 h-100" style="position:absolute;top:0;left:0; transition: 0.5s;"
                  [ngStyle]="{backgroundColor: (img.pngFile == auxDemoPngFile) ? '#f2c53d4d': 'transparent'}"></div>
                <img draggable="false" [src]="imagesService.getImage(img.pngFile)" *ngIf="img.mp4File==null">
                <video draggable="false" class="multiframe-video" muted
                  *ngIf="img.mp4File!=null && imagesService.getSingleImage(img.mp4File)!=null"
                  style="width: 100%;height: 100%;" autoplay loop>
                  <source [src]="imagesService.getSingleImage(img.mp4File)" type="video/mp4">
                  Your browser does not support the video.
                </video>
                <span *ngIf="img.type == BookImageType.SERIES && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">serie</span>
                <span *ngIf="img.type == BookImageType.CINE && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">cine</span>
                <span *ngIf="img.type == BookImageType.GRID && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">grid</span>
                <div *ngIf="page.type == BookPageType.IMAGES && img.isKo"
                  style="position: absolute;top: 2px;left: 4px;color: #f2c53de0">
                  <span *ngIf='isPageSmall' class='d-block' style="font-size: small;">KO</span>
                  <span *ngIf='!isPageSmall' class='d-block' style="font-size: small;">Imagen</span>
                  <span *ngIf='!isPageSmall' class='d-block' style="font-size: small;">Clave</span>
                </div>
                <div *ngIf="img.description!=null" class="text-golden"
                  style="position: absolute;bottom: 10px;width: 100%;text-align: center">{{img.description}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Botón flotante "Ver informe" en modo móvil landscape -->
<button *ngIf="isPageSmall && reportService.reports.length > 0" (click)="showMobileReportPanel = true" style="position: absolute; bottom: 20px; right: 20px; z-index: 999;
         width: 52px; height: 52px; border-radius: 50%; border: none;
         background-color: #101D30; box-shadow: 0 4px 12px rgba(0,0,0,0.4);
         display: flex; align-items: center; justify-content: center; cursor: pointer;">
  <svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 -960 960 960" width="26">
    <path fill="#f2c63d"
      d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z" />
  </svg>
</button>

<!-- Overlay de informe a pantalla completa (móvil landscape) -->
<div *ngIf="isPageSmall && showMobileReportPanel && reportService.actualReport != undefined" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;
         z-index: 1000; background-color: rgba(255,255,255,0.93);
         backdrop-filter: blur(6px); display: flex; flex-direction: column;">

  <!-- Barra superior del overlay: 3 zonas (índice | prev·next | cerrar) -->
  <div style="display: grid; grid-template-columns: 1fr auto 1fr; align-items: center;
              padding: 6px 12px; background-color: rgba(16,29,48,0.88); flex-shrink: 0; gap: 8px;">

    <!-- Zona izquierda: índice -->
    <span style="color: #f2c63d; font-size: 13px; white-space: nowrap;">
      Informe {{reportService.reportIndex + 1}} / {{reportService.reports.length}}
    </span>

    <!-- Zona central: prev / next (solo cuando hay más de un informe) -->
    <div *ngIf="reportService.reports.length > 1"
      style="display: flex; align-items: center; gap: 12px; justify-content: center;">
      <button [disabled]="!reportService.hasPrev()" (click)="reportService.prevReport()" style="background-color: #f2c63d; color: #101D30; border: none; border-radius: 4px;
               padding: 4px 16px; font-size: 18px; cursor: pointer; line-height: 1;"
        [style.opacity]="reportService.hasPrev() ? '1' : '0.3'">
        &lt;
      </button>
      <button [disabled]="!reportService.hasNext()" (click)="reportService.nextReport()" style="background-color: #f2c63d; color: #101D30; border: none; border-radius: 4px;
               padding: 4px 16px; font-size: 18px; cursor: pointer; line-height: 1;"
        [style.opacity]="reportService.hasNext() ? '1' : '0.3'">
        &gt;
      </button>
    </div>
    <!-- Placeholder cuando sólo hay un informe (mantiene alineación derecha) -->
    <div *ngIf="reportService.reports.length <= 1"></div>

    <!-- Zona derecha: cerrar -->
    <div style="display: flex; justify-content: flex-end;">
      <button (click)="showMobileReportPanel = false"
        style="background: none; border: none; cursor: pointer; padding: 4px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
          <path fill="white"
            d="M256-213.847 213.847-256l224-224-224-224L256-746.153l224 224 224-224L746.153-704l-224 224 224 224L704-213.847l-224-224-224 224Z" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Contenido del informe -->
  <div class="mobile-report-content" style="flex: 1; overflow: auto; position: relative;">

    <!-- PNG -->
    <div *ngIf="reportService.actualReport.type == 'png'" style="min-width: 100%; min-height: 100%; padding: 5px;
             display: flex; justify-content: center; align-items: flex-start;">
      <img draggable="false" [src]="reportService.actualReport.data"
        style="width: 100%; height: auto; object-fit: contain;">
    </div>

    <!-- PDF -->
    <div *ngIf="reportService.actualReport.type == 'pdf'"
      style="width: 100%; height: 100%;">
      <pdf-viewer [src]="reportService.actualReport.data" [render-text]="true"
        [original-size]="false" [zoom-scale]="'page-width'" [zoom]="0.9" [render-text-mode]="2"
        style="width: 100%; height: 100%"></pdf-viewer>
    </div>

  </div>
</div>

<app-animations></app-animations>
<!--<app-download-instructions></app-download-instructions>-->
<app-share-study (sendMail)="sendMail($event)" (downloadReport)="downloadReport()"></app-share-study>
<app-info-study></app-info-study>
<!--<app-download-modal></app-download-modal>-->

<!--  ESTO ES PARA PORTAL MODEL DEMO -->
<div class="index" [ngClass]="{'expanded': expandedIndex}">
  <!-- *ngIf="expandedIndex"  [ngStyle]="{'height': 'calc(40px * ' + (indexMenuList.length +1) +')', 'transition': 'height 2s'}">-->

  <div *ngFor="let list of indexMenuList">

    <div class="index-item" (click)="redirectTo(list.url)" *ngIf="list.url != null">
      <span class="text-golden">
        {{list.name}}
      </span>
    </div>

    <div class="index-item" (mouseover)='toggleDigitalBookIndex()' (mouseout)="closeDigitalBookIndexWithDelay()"
      *ngIf="list.url == null">
      <span class="me-2" style="cursor: pointer; rotate: -90deg;">
        <svg (click)="expandedDigitalBookIndex=true" *ngIf="!expandedDigitalBookIndex"
          xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
        </svg>
        <svg (click)="expandedDigitalBookIndex=false" *ngIf="expandedDigitalBookIndex"
          xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
        </svg>
      </span>
      <span class="text-golden">
        {{list.name}}
      </span>

    </div>

  </div>

</div>

<div class="digitalBookindex" (mouseover)='keepMenuOpen()' (mouseout)="closeDigitalBookIndexWithDelay()"
  [ngClass]="{'expanded': expandedDigitalBookIndex}">
  <!-- *ngIf="expandedDigitalBookIndex" [ngStyle]="{'height': 'calc(40px * ' + (indexDigitalBook.length +1) +')', 'transition': '0.5s;'}" -->


  <div *ngFor="let book of indexDigitalBook">

    <div class="index-item" (click)="redirectTo(book.url)">

      <span class="text-golden">
        {{book.name}}
      </span>
    </div>

  </div>

</div>